angular.module('dealerware.web.filters').filter('underscoreless', function() {
    return function (s) {
        return (angular.isString(s) && s.length > 0) ? s.replace(/_/g, ' ') : s;
    };
});